import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'ArtDoors',
    description: "Maatwerk stalen binnendeuren met glas. Ontwerp uw eigen deur in onze 3D-configurator, zie direct de prijs en laat hem vakkundig inmeten en plaatsen.",
    placeholder: '',
    url: getOrigin(),
    ogImage: '/images/fluted-partition.jpg'
}

export const mainNav = [
    { href: '/collectie', label: 'Collectie' },
    { href: '/configurator', label: 'Configurator' },
    { href: '/werkwijze', label: 'Werkwijze' },
    { href: '/inspiratie', label: 'Inspiratie' },
    { href: '/over-ons', label: 'Over ons' },
    { href: '/contact', label: 'Contact' }
]

export const legalNav = [
    { href: '/privacy', label: 'Privacybeleid' },
    { href: '/algemene-voorwaarden', label: 'Algemene voorwaarden' }
]
